import $axios from "@/api";

const state = () => ({
    datas: {
        report: [],
        dashboard: {
            rankSalesRetur: [],
            otherOutlet: [],
            grandTotal: []
        }
    },
    page: {
        headers: [],
        loadingDashboardData: false,
        loadingReportData: false,
    },
    filters: {
        id_mitra:'',
        id_perusahaan:'',
        ids_supervisor:[],
        ids_depo:[],
        ids_tim:[],
        group_by:'tim'
    },
    modal:{
        isOpen: false,
        backdrop: false,
        dismiss: true
    }
})

const mutations = {
    SET_DATAS(state, payload){
        state.datas[payload.target] = payload.data
    },
    RESET_DATA(state){
        state.datas = {
            report: [],
            dashboard: {
                rankSalesRetur: [],
                otherOutlet: [],
                grandTotal: []
        }}
    },
    setModal(state){
        const condition = !state.modal.isOpen
        if(condition){
            state.modal.backdrop = condition 
            setTimeout(() => {
                state.modal.isOpen = condition;
            }, 100);
        }else{
            state.modal.isOpen = condition 
            setTimeout(() => {
                state.modal.backdrop = condition;
            }, 100);
        }
    }
} 

const actions = {
    async getSalesReturDashboard({commit,state}){
        try{
            commit('RESET_DATA')
            state.page.loadingDashboardData = true
            state.page.loadingReportData = true
            const response = await $axios.get("report/tracking/sales-retur",{params: state.filters})
            commit('SET_DATAS',{target:'dashboard' ,data:response.data.data})
            state.page.headers = state.filters.group_by == 'toko' ? ['cust_no','nama_toko'] : ['nama_tim'];
            state.page.loadingDashboardData = false
        }catch (error) {
            state.page.loadingDashboardData = false
            console.error(error);
        }
    },
    async getSalesReturReport({commit,state}){
        try{
            const response = await $axios.get("report/tracking/sales-retur/download",{params: state.filters})
            commit('SET_DATAS',{target:'report' ,data:response.data.data})
            state.page.loadingReportData = false
        }catch (error) {
            state.page.loadingReportData = false
            console.error(error);
        }
    },
    isModal({commit}){
        commit('setModal')
    },
}

export default {
    namespaced: true,
    mutations,
    actions,
    state,
}